<template>
    <div class="">
        <form method="POST" :action="targetUrl">
            <input type="hidden" name="_token" :value="csrf" />
            <input type="hidden" name="_return_redirect" value="false" />
            <install-wizard-card>
                <template #top-header>
                    Report Setup
                </template>
                <template #top-content>
                    Subscribe users to receive our most popular reports, delivered automatically to their inbox on a weekly basis.<br/>
                    Users can also leverage SoniCloud to view these reports on-demand once you're up and running.<br/>
                    The frequency of reports can be changed once the site is completely activated.
                </template>

                <template #body-summary>
                    <div class="px-4 sm:px-12">
                        <div class="">
                            <div>
                                <p class="text-lg leading-6 font-medium text-gray-900">
                                    Excursion Report
                                </p>
                                <p class="mt-1 max-w-2xl text-sm leading-5 text-gray-500">
                                    This report gives you the daily minimum, maximum, twice daily data readings, a graphical summary, and a list of excursions.<br/>
                                    This is ideal for users who want a regulatory compliance focused report delivered to them automatically.
                                </p>
                            </div>
                        </div>
                        <div class="pt-8">
                            <p class="text-lg leading-6 font-medium text-gray-900">
                                Point Summary Report
                            </p>
                            <p class="mt-1 max-w-2xl text-sm leading-5 text-gray-500">
                                This is a management focused report that shows minimum, maximum, average readings, and alarms.<br/>
                                This helps provide an easily understandable overview of the status of your SoniCloud system.
                            </p>
                        </div>
                    </div>
                </template>

                <template #body-action>
                    <div class="px-4 sm:px-12">
                        <div class="pb-8">
                            <div class="">
                                <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
                                    <label
                                            class="block text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2">
                                        Excursion Report Recipients
                                    </label>
                                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                                        <div class="max-w-xs rounded-md shadow-sm">
                                            <select2
                                                    :options="users"
                                                    :multiple="true"
                                                    :value="excursionUsersSelected"
                                                    name="excursion_report_users[]"
                                            >
                                            </select2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="">
                            <div class="">
                                <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
                                    <label
                                            class="block text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2">
                                        Point Summary Report Recipients
                                    </label>
                                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                                        <div class="max-w-xs rounded-md shadow-sm">
                                            <select2
                                                    :options="users"
                                                    :multiple="true"
                                                    :value="summaryUsersSelected"
                                                    name="report_summary_users[]"
                                            >
                                            </select2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>

                <template #bottom-header>
                    Done automating sending reports to users?
                </template>
                <!--            <template #bottom-button-text></template>-->
                <template #bottom-button>
                    <a>
                        <button type="submit"
                                class="relative inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-blue-600 hover:bg-blue-500 focus:outline-none focus:ring-blue-200 focus:border-blue-700 active:bg-blue-700">
                            <slot name="bottom-button-text">Save Report Settings!</slot>
                        </button>
                    </a>
                </template>
            </install-wizard-card>
        </form>
    </div>
</template>

<script>
    import InstallWizardCard from "./InstallWizardCard";
    import Select2 from "@/components/elements/select2";
    import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";

    export default {
        name: "InstallWizardReportSetup",
        mixins: [SonicuCoreMixin],
        props: {
            users: {
                type: Object,
                default: {},
            },
            summaryUsersSelected: {
                type: Object,
                default: function() { return {} }
            },
            excursionUsersSelected: {
                type: Object,
                default: function() { return {} }
            },
            route: String,
        },
        components: {Select2, InstallWizardCard},
        methods: {
        },
        computed: {
            targetUrl(){
                return this.company.buildCompanyRoute('wizard/'+this.route);
            },
        }
    }
</script>

<style scoped>

</style>